import { defineAction } from '~/prix'
import { z } from 'zod'
import roadMaintenanceUpdateAction from './roadMaintenanceUpdate.action.json' with { type: 'json' }
import { roadMaintenanceObject } from '../roadMaintenanceObject'
import { operatorObject } from '../../operator/operatorObject'
import { materialObject } from '../../material/materialObject'
import { heavyMachineryObject } from '../../heavyMachinery/heavyMachineryObject'

const roadMaintenanceUpdateDefinition = defineAction({
  ...roadMaintenanceUpdateAction,

  input: roadMaintenanceObject
    .pick({
      id: true,
      scheduledDate: true,
      communityId: true,
      street: true,
      serviceLocation: true,
      lengthMeters: true,
      responsibleCitizenId: true,
      status: true,
      observations: true,
    })
    .partial()
    .required({ id: true })
    .extend({
      machineUsages: z
        .array(
          z.object({
            heavyMachineryId: heavyMachineryObject.shape.id,
            operatorId: operatorObject.shape.id.nullish(),
            startTime: z.string().nullish(),
            endTime: z.string().nullish(),
          }),
        )
        .optional(),
      materials: z.array(materialObject.shape.id).optional(),
    }),

  output: z.object({}),
})

export default roadMaintenanceUpdateDefinition
